export default {
    isLoggedIn: null,
    emailTokenId: null,
    OtpVerification: null,
};
